
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"68","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#CDAA37","cx":"34","cy":"34","r":"34"}}),_c('path',{attrs:{"d":"M57.435 45.766a2.886 2.886 0 00-3.785-1.572l-1.602.67-2.806-7.418c3.473-2.548 4.698-7.301 2.501-11.123l-6.28-10.955a2.322 2.322 0 00-2.9-.99l-8.287 3.45-8.288-3.45c-2.038-.928-3.72-1.657-4.778 0l-4.402 11.945c-2.56 7.59-5.076 17.951-5.692 19.436a.584.584 0 00.312.764l11.768 4.907a.572.572 0 00.754-.313c.61-1.485 7.846-14.333 8.86-18.133l1.69-4.165 1.24 4.165c1.015 3.8 4.474 6.21 8.223 6.21.312 0 .63-.06.95-.096l2.85 7.542-1.603.67a2.916 2.916 0 00-1.566 3.807.575.575 0 00.754.313l11.775-4.907a.582.582 0 00.312-.757zm-39.24-20.22c2.674-7.302 4.2-10.953 4.578-10.953.377 0 3.408 1.164 9.092 3.49.157 1.471.31 2.86.463 4.169.152 1.308.387 3.267.705 5.878l-14.837-2.584zm16.209-5.206l9.804-4.033 3.786 6.522-11.63 4.783-1.96-7.272z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    